
import React, {useEffect, useRef} from 'react';

export const Scroller = () => {
	const ref = useRef<HTMLDivElement>(null);
	useEffect(() => {
		if (ref.current) {
			ref.current.scrollIntoView({
				behavior: 'smooth',
				block: 'nearest',
				inline: 'start',
			});
		}
	}, [ref.current]);

	return <div ref={ref} />;
};
